import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import ReactSVG from 'react-svg';
import { connect } from 'react-redux';

import logoGray from '../../assets/images/logo-gray.png';
import facebook from '../../assets/images/soc_FB.svg';
import bluesky from '../../assets/images/soc_bluesky.svg';
import linkedin from '../../assets/images/soc_linkedin.svg';
import rss from '../../assets/images/soc_rss.svg';
import mail from '../../assets/images/soc_mail.svg';
import { Wrapper } from './style';

class Footer extends Component {
  render() {
    const { lang } = this.props;

    return (
      <Wrapper>
        <div className="root-container">
          <div className="container">
            <div className="logo-container">
              <img alt="Logo of OpenEdition" src={logoGray} />
            </div>

            <div className="description">
              <FormattedMessage id="footer.description" />
            </div>

            <div className="column-container">
              <div className="first-column column">
                <div>
                  <FormattedMessage id="footer.follow_us" />
                </div>
                <div className="icon-container">
                  <a
                    href="https://bsky.app/profile/openedition.bsky.social"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ReactSVG svgStyle={{ height: 29 }} src={bluesky} />
                  </a>
                  <a
                    href="https://www.facebook.com/openedition"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ReactSVG svgStyle={{ height: 29 }} src={facebook} />
                  </a>
                  <a
                    href="https://fr.linkedin.com/company/cleo-centre-pour-l%27%E2%80%8B-dition-lectronique-ouverte-"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ReactSVG svgStyle={{ height: 29 }} src={linkedin} />
                  </a>
                  <a
                    href="https://www-openedition-org.ezscd.univ-lyon3.fr/backend"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ReactSVG svgStyle={{ height: 29 }} src={rss} />
                  </a>
                  <a href="mailto:contact@openedition.org">
                    <ReactSVG svgStyle={{ height: 29 }} src={mail} />
                  </a>
                </div>

                <a
                  className="abo-link"
                  href="https://www-openedition-org.ezscd.univ-lyon3.fr/41045"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage id="footer.subscribe" />
                  <br />
                  <FormattedMessage id="footer.to_letter" />
                </a>
              </div>

              <div className="second-column column">
                <a
                  href={`https://www-openedition-org.ezscd.univ-lyon3.fr/11932?lang=${lang}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage id="footer.cgu" />
                </a>
                <a
                  href={`https://www-openedition-org.ezscd.univ-lyon3.fr/11893?lang=${lang}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage id="footer.credits" />
                </a>
                <a
                  href={`https://www-openedition-org.ezscd.univ-lyon3.fr/19362?lang=${lang}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage id="footer.terms" />
                </a>
                {/*<a href="#" target="_blank" rel="noopener noreferrer">
                <FormattedMessage id="footer.access" />
              </a>*/}
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

export default connect(
  ({ ui: { lang } }) => ({
    lang
  }),
  () => ({})
)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/index.js